"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerError = exports.AppHRP = exports.AppCoinType = void 0;
exports.AppCoinType = {
    Cosmos: 118,
    Terra: 330,
};
exports.AppHRP = {
    Cosmos: "cosmos",
    Terra: "terra",
};
class LedgerError extends Error {
    constructor(message) {
        super(message);
        this.name = "LedgerError";
    }
}
exports.LedgerError = LedgerError;
//# sourceMappingURL=types.js.map